import { environment } from 'src/environments/environment';

type PartnersBrand = {
  attribution: string;
  showHelpCenter: boolean;
  title: string;
  isThemeSwitchSupported: boolean;
};

export const getPartnersBrandConfig = (): PartnersBrand => {
  return environment.brand;
};
